import { render } from "./tool.vue?vue&type=template&id=60f3d5f0"
import script from "./tool.vue?vue&type=script&lang=js"
export * from "./tool.vue?vue&type=script&lang=js"

import "./tool.vue?vue&type=style&index=0&id=60f3d5f0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__